export const linkStyle = {
  color: '#ffffff',
  textDecoration: 'none',
  float: 'auto',
}
